import React from 'react'
import { 
    Button, 
    Table, 
    Row, 
    Divider, 
    Popconfirm, 
    Modal, 
    Input, 
} from 'antd'
import { firestore } from '../../../service/firebase'
import './Notable.scss'

const { TextArea } = Input


export default class Notable extends React.Component {
    
    columns = [
        { title: "Name", dataIndex: 'name', key: 'name' },
        { title: "Detail", dataIndex: 'detail', key: 'detail' },
        { title: "Link", dataIndex: 'link', key: 'link', render: link => {
            return <a href={link}>{link}</a>
        } },
        { title: 'Actions', dataIndex: '', key: 'action', render: (item) => {
            return (
                <span>
                    <a onClick={() => this.handleEdit(item)}>Edit</a>
                    <Divider type="vertical" />
                    <Popconfirm title="Are you sure delete?" onConfirm={() => this.handleDelete(item)} okText="Yes" cancelText="No">
                        <a>Delete</a>
                    </Popconfirm>
                </span>
            )
        }}
    ]

    dataList = []
    
    state = {
        showModal: false,
    }

    /*--------------------------------------------------------------*/
    /* Constructor */
    /*--------------------------------------------------------------*/

    constructor(props) {
        super(props)
        this.loadEvents()
    }


    /*--------------------------------------------------------------*/
    /* Load data */
    /*--------------------------------------------------------------*/

    loadEvents() {

        firestore.collection('Notables')
        .onSnapshot(snapshot => {
    
            snapshot.docChanges().forEach(change => {
    
                let data = change.doc.data()
    
                if(change.type === 'added') {

                    this.dataList.push(data)

                } else if(change.type === 'modified') {

                    this.dataList = this.dataList.map(item => {
                        if(item.id === data.id) {
                            return data
                        } else {
                            return item
                        }
                    })

                } else {

                    for(let i = 0; i < this.dataList.length; i++) {
                        let item = this.dataList[i]
                        if(item.id === data.id) {
                            this.dataList.splice(i, 1)
                            break
                        }
                    }

                }
            })
    
            this.forceUpdate()
        })
    
    }


    /*--------------------------------------------------------------*/
    /* Format functions */
    /*--------------------------------------------------------------*/

    dateFormat(date) {
        let year = this.numberFormat(date.getFullYear())
        let month = this.numberFormat(date.getMonth())
        let day = this.numberFormat(date.getDate())
        let hr = this.numberFormat(date.getHours())
        let min = this.numberFormat(date.getMinutes())

        return year + '/' + month + '/' + day + ' ' + hr + ':' + min
    }

    numberFormat(num) {
        return num > 9 ? num + '' : '0' + num
    }

    dateDetail(date) {
        if(date) {
            let dateStr = this.dateFormat(date.toDate())
            return (<div>{dateStr}</div>)
        } else {
            return (<div> - </div>)
        }
    }


    /*--------------------------------------------------------------*/
    /* Handle Functions */
    /*--------------------------------------------------------------*/

    handleAdd() {
        this.eventEdit = false
        this.setState({
            id: '',
            name: '',
            detail: '',
            link: '',
            showModal: true,
        })
    }

    handleEdit(item) {
        this.eventEdit = true
        let state = this.state

        let newState = Object.assign(state, item, {
            showModal: true,
        })

        console.log(newState)
        this.setState(newState)
    }

    handleChange(key, value) {
        let state = this.state
        state[key] = value
        this.setState(state)
    }
    
    handleDelete(item) {
        firestore.collection('Notables').doc(item.id).delete();
    }

    handleOK() {
        let state = this.state

        let id = state.id
        let ref

        if(!this.eventEdit) {
            ref = firestore.collection('Notables').doc()
            id = ref.id
        } else {
            ref = firestore.collection('Notables').doc(id)
        }

        let object = {
            id,
            name: state.name ? state.name : '',
            detail: state.detail ? state.detail : '',
            link: state.link ? this.link(state.link) : '',
        }

        console.log(object)

        ref.set(object)
        this.setState({showModal: false})
    }

    link(text) {
        if(text.substring(0, 4) === 'http') {
            return text
        } else {
            return 'http://' + text
        }
    }

    handleClose() {
        this.setState({showModal: false})
    }


    /*--------------------------------------------------------------*/
    /* Render Functions */
    /*--------------------------------------------------------------*/
   
    render() {

        return (
            <div className="notable">

                <Row style={{textAlign: 'right', padding: 10}}>
                    <Button type="primary" icon="plus" onClick={() => this.handleAdd()}>Notables</Button>
                </Row>

                <Table 
                    style={{margin: 10, background: 'white'}}
                    columns={this.columns}
                    rowKey={record => record.id}
                    dataSource={this.dataList} />

                
                <Modal
                    title={this.eventEdit ? 'Edit Notables' : "Add Notables"}
                    visible={this.state.showModal}
                    onOk={() => this.handleOK()}
                    onCancel={() => this.handleClose()}>

                    <Row className="input-row">
                        <div className="input-label">Name</div>
                        <Input value={this.state.name} onChange={evt => this.handleChange('name', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Link</div>
                        <Input value={this.state.link} onChange={evt => this.handleChange('link', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Detail</div>
                        <TextArea autosize={{minRows: 3, maxRows: 9}} value={this.state.detail} onChange={evt => this.handleChange('detail', evt.target.value)} />
                    </Row>

                </Modal>

            </div>
        )
    }
}
